import { createContext, useCallback, useContext, useMemo } from "react";
import useLocalStorage from "react-use/lib/useLocalStorage";
import { Venue } from "@ticketingplatform/api/dist/venue/__generated__/Venue";
import { LOCAL_STORAGE_VENUE_KEY } from "setup/consts";
import { useApolloClient } from "@apollo/client";

export interface VenueContextValue {
  venue?: Venue;
  setVenue(value?: Venue): void;
}

const VenueContext = createContext<VenueContextValue>({
  setVenue: () => {
    throw new Error(
      "could not find `setVenue()` are you sure you are inside of `VenueContextProvider` provider?"
    );
  },
});

export const VenueContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const apollo = useApolloClient();

  const [venue, setVenueValue, removeVenueValue] = useLocalStorage<Venue>(
    LOCAL_STORAGE_VENUE_KEY
  );

  const setVenue = useCallback(
    async (value?: Venue) => {
      if (value) {
        setVenueValue(value);
      } else {
        removeVenueValue();
      }

      await apollo.resetStore();
    },
    [apollo, removeVenueValue, setVenueValue]
  );

  const value = useMemo(() => ({ venue, setVenue }), [setVenue, venue]);

  return (
    <VenueContext.Provider {...{ value }}>{children}</VenueContext.Provider>
  );
};

export const useVenueContext = () => useContext(VenueContext);
